import React from "react";

function LabourAmmendment() {
  return (
    <div>
      <article className="prose lg:prose-base max-w-none">
        <h2 className="underline underline-offset-8">
          Labour Amendment Discussion: Removal of 3 Months Notice Period
        </h2>
        <p>
          The new labour amendment repealed section 12(4a) of the Labour Act
          which allowed both employers and employees to terminate a permanent
          contract of employment or a contract for a period of two or more years
          upon giving three months&apos; notice. This previous position permitted
          employers to terminate contracts of employment without any fault on
          the part of the employee provided that a three months&apos; notice is
          given.In terms of the amendment only employees are allowed to
          terminate permanent contracts or contracts of two or more years on
          notice upon resignation or retirement.
        </p>
        The fact that employers are no longer permitted to terminate permanent
        contracts of employment on notice does not mean that such contract
        cannot be terminated. The following options are still available to the
        employer:
        <br />
        <p className="pl-4">
          a. Termination of employment for misconduct. Such termination to be
          lawful must be done in terms of a registered employment code of
          conduct for that industry. In the absence of a registered employment
          code of conduct, then the model code must be used as a guide.
          <br />
          b. Mutual Termination can also be utilised by both parties. This is an
          agreement between an employer and an employee which sets out the terms
          of an amicable separation.
          <br />
          i. for the purposes of exporting lithium samples outside Zimbabwe for
          assaying; or
          <br />
          c. Retrenchment is also an available option. Retrenchment allows
          employers to terminate a contract of employment for the purpose of
          reducing expenditure/costs and adapting to technological change, among
          other things.
          <br />
        </p>
        <p className="italic">
          <b>DISCLAIMER : </b>This article is for information purposes only and does not constitute legal advice. This article is not intended to create a legal practitioner – client relationship. You should not take action based on this information without consulting one of our legal practitioners.
        </p>
       
      </article>
    </div>
  );
}

export default LabourAmmendment;
